// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Wocl","info":"PatientInfo_info__3O5H_"};